import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import Modal from "react-modal";
import { ExportToCsv } from "export-to-csv";
// import { listUserAuthEvents } from '../../../../src/actions/users';
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70vw",
    border: "8px solid #9ba5ad",
    maxHeight: "100vh",
    overflowY: "auto",
  },
};

const ViewUserDetails = (props) => {
  const dispatch = useDispatch();
  // const clearUserDetails = () => dispatch({ type: 'SET_USER_DETAILS', data: { userDetails: undefined } });

  useEffect(() => {
    return () => {
      dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
    };
  }, [dispatch]);

  const eventsList = props.eventsList;
  const clearAuthEvents = props.clearAuthEvents;
  useEffect(() => {
    if (eventsList && eventsList.length > 0) {
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(eventsList);
      clearAuthEvents();
    }
  }, [eventsList, clearAuthEvents]);

  const { userDetails } = props;
  const {
    "custom:uid": uid,
    email,
    given_name,
    family_name,
    "custom:company": company,
    "custom:Address": Address,
    "custom:City": City,
    "custom:State": State,
    "custom:Zip": Zip,
    "custom:Country": Country,
    "custom:phoneNumber": phoneNumber,
    "custom:mobileNumber": mobileNumber,
    "custom:Groups": roles,
    Enabled,

    // 	'email',
    // 'given_name',
    // 'name',
    // 'family_name',
    // 'preferred_username',
    // 'address',
    // 'phone_number',
    // 'custom:uid',
    // 'custom:displayname',
    // 'custom:title',
    // 'custom:company',
    // 'custom:phoneNumber',
    // 'custom:mobileNumber',
    // 'custom:accessrole',
    // 'custom:status',
    // 'custom:Address',
    // 'custom:City',
    // 'custom:State',
    // 'custom:Zip',
    // 'custom:Country',
  } = userDetails;

  return (
    <>
      <Modal
        isOpen={props.modal}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={props.toggle}
      >
        <Container fluid>
          <Form>
            <h5>User Details</h5>
            <hr />
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="uid" id="uid" className="label">
                    User ID:
                  </Label>
                  <Label for="UIDVal" id="UIDVal">
                    {uid}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="email" id="email" className="label">
                    Email ID:
                  </Label>
                  <Label for="emailVal" id="emailVal">
                    {email}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="firstName" id="firstName" className="label">
                    First Name:
                  </Label>
                  <Label for="firstNameVal" id="firstNameVal">
                    {given_name}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="lastName" id="lastName" className="label">
                    Last Name:
                  </Label>
                  <Label for="lastNameVal" id="lastNameVal">
                    {family_name}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="company" id="company" className="label">
                    Company:
                  </Label>
                  <Label for="companyVal" id="companyVal">
                    {company}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="phoneNumber" id="phoneNumber" className="label">
                    Company Phone Number:
                  </Label>
                  <Label for="phoneNumberVal" id="phoneNumberVal">
                    {phoneNumber}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {/* <Row>
								<Col sm={6}>
									<FormGroup>
										<Label for='sapcontactid' id='sapcontactid' className='label'>
											SAP Contact id:
										</Label>
										<Label for='sapcontactidVal' id='sapcontactidVal'>
											{sapcontactid}
										</Label>
									</FormGroup>
								</Col>
								<Col sm={6}>
									<FormGroup>
										<Label for='sapAccountid' id='sapAccountid' className='label'>
											SAP Account id:
										</Label>
										<Label for='sapAccountidVal' id='sapAccountidVal'>
											{sapAccountid}
										</Label>
									</FormGroup>
								</Col>
							</Row> */}
            <Row>
              <Col sm={6}>
                {/* <FormGroup>
										<Label for='resourceid' id='resourceid' className='label'>
											Resource ID:
										</Label>
										<Label for='resourceidval' id='resourceidval'>
											{resourceid}
										</Label>
									</FormGroup> */}
                <FormGroup>
                  <Label for="Address" id="Address" className="label">
                    Address:
                  </Label>
                  <Input
                    style={{
                      backgroundColor: "#ffffff",
                    }}
                    type="textarea"
                    // for='Address'
                    id="Address"
                    disabled
                    value={Address}
                  />
                </FormGroup>
              </Col>
              <Col sm={6}>
                {/* <FormGroup>
										<Label for='contracttype' id='contracttype' className='label'>
											Contract Type:
										</Label>
										<Label for='contracttype' id='contracttype'>
											{contracttype}
										</Label>
									</FormGroup> */}
                <FormGroup>
                  <Label for="City" id="City" className="label">
                    City:
                  </Label>
                  <Label for="CityVal" id="CityVal">
                    {City}
                  </Label>
                </FormGroup>
                <FormGroup>
                  <Label for="State" id="State" className="label">
                    State:
                  </Label>
                  <Label for="StateVal" id="StateVal">
                    {State}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="Zip" id="Zip" className="label">
                    Zip/Postal Code:
                  </Label>
                  <Label for="ZipVal" id="ZipVal">
                    {Zip}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="Country" id="Country" className="label">
                    Country:
                  </Label>
                  <Label for="CountryVal" id="CountryVal">
                    {Country}
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="mobileNumber" id="mobileNumber" className="label">
                    Mobile Number:
                  </Label>
                  <Label for="mobileNumberVal" id="mobilrNumberVal">
                    {mobileNumber}
                  </Label>
                </FormGroup>
                <FormGroup>
                  <Label for="status" id="status" className="label">
                    Status:
                  </Label>
                  <Label for="emailVal" id="emailVal">
                    {Enabled ? "Active" : "Inactive"}
                  </Label>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="accessrole" id="accessrole" className="label">
                    Role(s):
                  </Label>
                  <Input
                    style={{ backgroundColor: "#ffffff" }}
                    type="textarea"
                    // for='accessroleVal'
                    id="accessroleVal"
                    disabled
                    value={roles}
                  />
                </FormGroup>
              </Col>
            </Row>
            {/* <button
								style={{
									background: 'none !important',
									border: 'none',
									padding: '0 !important',
									color: '#069',
									textDecoration: 'underline',
									cursor: 'pointer',
									float: 'left'
								}}
								onClick={e => {
									e.preventDefault();
									this.props.listUserAuthEvents(userDetails.Username);
								}}
							>
								Get Auth Events
							</button> */}
            <Button
              onClick={(e) => {
                e.preventDefault();
                props.toggle();
              }}
              style={{ float: "right" }}
            >
              Cancel
            </Button>
          </Form>
        </Container>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    eventsList: state.users.events,
  };
};
export default connect(mapStateToProps)(ViewUserDetails);
